import { memoize } from 'lodash';

import { hasMetaOsHubContext } from './context';
import { hasMetaOsHostNameInContentUrl } from './hasMetaOsHostNameInContentUrl';

type IsInMetaOsHub = () => Promise<boolean>;
export const isInMetaOsHub: IsInMetaOsHub = memoize(
  async () => hasMetaOsHostNameInContentUrl() || !!(await hasMetaOsHubContext())
);
